import configData from "../../config.json";
import axios from "axios";

export const RegisterStudent = async (v) => {
  var config = {
    method: "POST",
    url: configData.API_ENDPOINT + `user`,
    headers: {
      "Content-Type": "application/json",
    },
    data: v,
  };
  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};

export const SendOtp = async (v) => {
  try {
    const response = await axios.post(configData.API_ENDPOINT + `user/otp`, v, {
      headers: {"Content-Type": "application/json"},
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    return {success: false, message: "Network error. Please try again later."};
  }
};

export const ValidateOtp = async (v) => {
  try {
    const response = await axios.post(
      configData.API_ENDPOINT + `user/validate`,
      v,
      {headers: {"Content-Type": "application/json"}}
    );
    return response.data;
  } catch (error) {
    return {success: false, message: error.message};
  }
};
